import ProductMediaUpload from "./product-media-upload";

export default ProductMediaUpload;